import { T } from '@tribeplatform/react-components/i18n'

import type { TableCounterProps } from './types.js'

export const PostsCounter = ({
  matchedCount,
  totalCount,
}: TableCounterProps) => {
  return (
    <div className="flex items-center space-s-1">
      {totalCount === matchedCount ? (
        <span className="font-medium">
          <T
            defaultMessage="{posts_count, plural, =0 {No posts} =1 {# post} other {# posts}}"
            id="Generics.Posts.Plural"
            values={{
              posts_count: totalCount,
            }}
          />
        </span>
      ) : (
        <span>
          <T
            defaultMessage="<bold>{matched_count, plural, one {# post} other {# posts}} matched</bold> of {total_count, number}"
            id="Admin.PostsList.TableCounter"
            values={{
              matched_count: matchedCount,
              total_count: totalCount,
              bold: chunks => <span className="font-medium">{chunks}</span>,
            }}
          />
        </span>
      )}
    </div>
  )
}
